export const getClass = (classes: (string | boolean)[]) =>
    classes.filter(Boolean).join(' ');